var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.talk}},[_vm._v(" "+_vm._s(_vm.textPrompt)+" "),_c('audio',{ref:"audioTalk",attrs:{"src":_vm.audio}})])}
var staticRenderFns = []

export { render, staticRenderFns }